import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialConsentImpact = async (trialId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/trials/${trialId}/consent/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

// Number of active patients who would have to sign again if the trial's consent changed
const useGetTrialConsentImpact = ({ trialId }) => {
  return useQuery({
    queryKey: ["trial-consent-impact", trialId],
    queryFn: () => fetchTrialConsentImpact(trialId),
    enabled: false,
  });
};

export default useGetTrialConsentImpact;
